import { AxiosResponse } from "axios";

import {
  ISpirometrySession,
  ISpirometrySessionDetails,
  ISpirometrySessionsFilters,
} from "../../@types/admin/AdminSpirometry";
import { IPaginatedResponse } from "../../@types/PaginatedResponse";
import { api } from "../api";

/**
 * Spirometry Sessions admin page (EN-4125), replacing the CMS "Spirometry test
 * assessment sessions/results" screens. Read-only and server-paginated: there
 * is a session per spirometry test session across every patient.
 */
export const spirometryService = {
  async getSessions(
    filters: ISpirometrySessionsFilters
  ): Promise<AxiosResponse<IPaginatedResponse<ISpirometrySession[]>>> {
    return api.get<IPaginatedResponse<ISpirometrySession[]>>(
      "/Retool/Spirometry/Sessions",
      {
        params: {
          page: filters.page,
          pageSize: filters.pageSize,
          search: filters.search || undefined,
          sortBy: filters.sortBy,
          sortDescending: filters.sortDescending,
        },
      }
    );
  },

  async getSession(
    id: number
  ): Promise<AxiosResponse<ISpirometrySessionDetails>> {
    return api.get<ISpirometrySessionDetails>(
      `/Retool/Spirometry/Sessions/${id}`
    );
  },
};
